import Validate from './Validate'
import Upload from './Upload'

export default
{
    Validate,
    Upload,
}